// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sy-button-dots[data-v-6d4911e5],.sy-buttons[data-v-6d4911e5]{display:flex;align-items:center}.sy-button-dots[data-v-6d4911e5]{width:32px;height:32px;cursor:pointer;background:#eff5fb;border-radius:4px;margin-left:10px;justify-content:center}.sy-button-dots[data-v-6d4911e5]:hover{background:#e6eff8}.sy-button-dots .el-icon-more[data-v-6d4911e5]{color:#037aff}", ""]);
// Exports
module.exports = exports;
